import { UI, Utils } from 'common';
import React, { useEffect, useState } from 'react';
import ContactsCommunication from '../utils/ContactsCommunication';

const { WrappedDragAndDropFileUpload } = UI;
const { withLayoutAndModalContexts } = Utils;

const UploadContacts = ({
	isFileUploadSuccessful,
	importedContactsFileData,
	uploadContactsCallback,
	modalContext: { showError },
}) => {
	const [isImportFileTypeValid, setIsImportFileTypeValid] = useState(true);
	const [isUploading, setIsUploading] = useState(false);
	const [isFileUploaded, setIsFileUploaded] = useState(isFileUploadSuccessful);
	const [importedFileName, setImportedFileName] = useState(
		importedContactsFileData ? importedContactsFileData.importedFileName : ''
	);

	useEffect(() => {
		setIsFileUploaded(isFileUploadSuccessful);
	}, [isFileUploadSuccessful]);

	const onSelect = ({ files }) => {
		const importedFile = files[0];
		const isFileTypeValid = importedFile.name.indexOf('.csv') !== -1;

		setIsImportFileTypeValid(isFileTypeValid);

		if (isFileTypeValid) {
			const fileReader = new FileReader();

			setIsUploading(true);
			setImportedFileName(importedFile.name);
			fileReader.readAsText(importedFile);

			fileReader.onload = async () => {
				const fileUploadFormData = new FormData();
				fileUploadFormData.append('file', importedFile);

				setIsFileUploaded(true);

				const response = await ContactsCommunication.uploadFile({
					templateId: 0,
					duplicateHandle: 0,
					continueWithErrors: false,
					groupId: 0,
					fileData: fileUploadFormData,
				});

				if (ContactsCommunication.isSuccessful(response)) {
					setIsFileUploaded(true);
					setIsUploading(false);
					uploadContactsCallback({
						importedFileName: importedFile.name,
						...response.data,
					});
				} else {
					setIsFileUploaded(false);
					showError({ response });
				}
			};
		}
	};

	return (
		<div className="upload-contacts">
			{!isFileUploaded && <h1 className="primary-header">Upload a CSV File</h1>}
			{!isImportFileTypeValid && (
				<span className="error-message">
					Invalid file type. Please upload a CSV file.
				</span>
			)}
			<div className="body">
				<div>
					<WrappedDragAndDropFileUpload
						className="importContactsUpload"
						dataqa="importcontactsupload"
						onSelect={onSelect}
						supportedFormats="CSV"
						onUploadComplete={isFileUploaded}
						isUploading={isUploading}
						importedFileName={importedFileName}
					/>
				</div>
			</div>
		</div>
	);
};

export default withLayoutAndModalContexts(UploadContacts);
